import ApiManager from "./ApiManager";

let apiManager = ApiManager.getInstance();

export default class ApiClass {
  static singleton;
  static getInstance() {
    if (ApiClass.singleton == null) {
      ApiClass.singleton = new ApiClass();
    }
    return ApiClass.singleton;
  }

  setCreds = (token) => {
    apiManager.setCreds(token);
  };

  loginWeb = (email, password) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post("/login-web", { email: email, password: password })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  register = (firstName, lastName, email, password) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post("/register", {
          firstName: firstName,
          lastName: lastName,
          email: email,
          password: password,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  googleLogin = (tokenId) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post("/googleLogin", { tokenId: tokenId })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  verifyOtp = (otp, email) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post("/verifyOtp", { otp: otp, email: email })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  forgetPassword = (email) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post("/forgetPassword", { email: email })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  changePassword = (token, password, confirmPassword) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/changePassword/${token}`, {
          password: password,
          confirmPassword: confirmPassword,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getPrices = (gameID) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/getPrices/${gameID}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getLicenseKeys = (type) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/getLicenseKeys`, { type: type })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  orderHistory = (rowsPerPage, page) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/orderHistory`, { rowsPerPage: rowsPerPage, page: page })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  createOrder = (data) => {
    console.log("data is api calss is", data);

    if (data[0].token) {
      return new Promise((resolve, reject) => {
        apiManager
          .post(`/upgradeSubscriptionCharge`, { ...data[0] })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        apiManager
          .post(`/orders`, { cart: data })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  };

  createStripeCheckoutSession = ({ productId, quantity, gameId }) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/stripe/checkout-session`, {
          productId: String(productId),
          quantity: Number(quantity),
          gameId: Number(gameId),
        })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  pauseStripeSubscription = (subID) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/stripe/subscription/pause`, { subID })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  resumeStripeSubscription = (subID) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/stripe/subscription/resume`, { subID })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  cancelStripeSubscription = (subID) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/stripe/subscription/cancel`, { subID })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  getStripeSubscriptionDetails = (subID) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/stripe/subscription/details`, { subID })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  listStripeSubscriptions = () => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/stripe/subscription/list`, {})
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  onApprove = (orderID, data) => {
    return new Promise((resolve, reject) => {
      if (data.token) {
        apiManager
          .post(`/upgradeSubscriptionSuccess/${orderID}`, { ...data })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      } else {
        apiManager
          .post(`/orders/${orderID}`, { ...data })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      }
    });
  };

  getLatestBlogList = () => {
    return new Promise((resolve, reject) => {
      apiManager
        .get(`/getLatestBlogList`, {})
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getBlog = (blog) => {
    return new Promise((resolve, reject) => {
      apiManager
        .get(`/getBlog/${blog}`, {})
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  generateTrialKey = (gameID) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/generateTrialKey`, { gameID: parseInt(gameID) })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  dashboardInfo = () => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/dashboardInfo`, {})
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  createSub = (data) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/createSub`, { ...data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  subApproved = (data) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/subApproved`, { ...data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getSubDetails = (data) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/getSubDetails`, { ...data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  upgradeSubscription = (data) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/upgradeSubscription`, { ...data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  confirmRemainingCharge = (data) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/confirmRemainingCharge`, { ...data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  reviseSub = (data) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/reviseSub`, { ...data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  suspendSub = (subID) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/suspendSub/${subID}`, {  })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  resumeSub = (subID) => {
    return new Promise((resolve, reject) => {
      apiManager
        .post(`/resumeSub/${subID}`, {  })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
}
